module.exports = __webpack_public_path__ + "img/alexandria_forbidden_veil.ef07dceb.png";